import React, { useRef } from "react";
import { Box } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import TextInput from "../../../components/Globo/Input/TextInput";
import IconButton from "../../../components/Globo/Button/IconButton";

const CultureHubFilter = ({ term, onChange, onSubmit }) => {
  const inputRef = useRef(null);

  const handleClear = () => {
    // reuses the input's onChange handler, which only reads event.target.value
    onChange({ target: { value: "" } });
    if (inputRef.current) inputRef.current.focus();
  };

  return (
    <Box
      component="form"
      role="search"
      onSubmit={onSubmit}
      sx={{ maxWidth: 480, "@media (max-width: 980px)": { maxWidth: "100%" } }}
    >
      <TextInput
        type="search"
        placeholder="Procurar"
        value={term}
        onChange={onChange}
        autoComplete="off"
        inputRef={inputRef}
        inputProps={{
          "aria-label": "Procurar no HUB de Cultura",
          autoComplete: "off",
        }}
        endAdornment={
          <>
            {!!term && (
              <IconButton
                type="button"
                size="small"
                icon={<CloseRoundedIcon fontSize="small" />}
                aria-label="Limpar busca"
                onClick={handleClear}
              />
            )}
            <IconButton
              type="submit"
              size="small"
              icon={<SearchRoundedIcon fontSize="small" aria-hidden="true" />}
              aria-label="Buscar"
            />
          </>
        }
        width="280px"
        sx={{ "@media (max-width: 980px)": { width: "100%" } }}
      />
    </Box>
  );
};

export default CultureHubFilter;
